import type { components } from '@pba/types-openapi-client';
import { CommunityMemberRow } from './community-member-row';

type P = {
  members: Array<components['schemas']['UserList']>;
};

/**
 * @deprecated Use direct member list implementation instead
 */
const MembersList = ({ members }: P) => (
  <div style={{ display: 'table', tableLayout: 'fixed', width: '100%' }}>
    {members.map((member) => (
      <CommunityMemberRow key={member.id} member={member} />
    ))}
  </div>
);

export default MembersList;
